import React from "react";

const SampleCSAT = ({ data }) => {
  return (
    <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6">
      
      {/* Header */}
      <div className="bg-blue-900 text-white px-4 py-2 font-semibold mb-4 rounded">
        Survey Details
      </div>

      {/* Top Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        
        {/* Left */}
        <div className="lg:col-span-2 space-y-4">
          
          <div>
            <label className="text-sm text-gray-400">CSAT ID</label>
            <div className="font-semibold">{data.csatID}</div>
          </div>

          <div>
            <label className="text-sm text-gray-400">Title</label>
            <input className="w-full bg-gray-900 border border-gray-600 p-2 rounded" defaultValue={data.title}/>
          </div>

          <div>
            <label className="text-sm text-gray-400">Objective</label>
            <textarea className="w-full bg-gray-900 border border-gray-600 p-2 rounded h-24" defaultValue={data.objective}/>
          </div>

          <div className="flex gap-2">
            <input className="flex-1 bg-gray-900 border border-gray-600 p-2 rounded" defaultValue={data.periodFrom}/>
            <span className="self-center">to</span>
            <input className="flex-1 bg-gray-900 border border-gray-600 p-2 rounded" defaultValue={data.periodTo}/>
          </div>

          <input className="w-full bg-gray-900 border border-gray-600 p-2 rounded" defaultValue={data.department} placeholder="Department"/>
          <input className="w-full bg-gray-900 border border-gray-600 p-2 rounded" defaultValue={data.owner} placeholder="Owner"/>

          <div className="flex gap-2">
            <span className="text-gray-400">Newness:</span>
            <span className="text-emerald-400">{data.newness}</span>
          </div>
        </div>

        {/* Right Actions */}
        <div className="space-y-2">
          {[
            "Help","Scope","RACI","State Machine","Integrations",
            "Attachment","External Fact Check","Telemetry",
            "Related Transactions","Questionnaire","Survey Participants","Final Report"
          ].map((btn, i) => (
            <button
              key={i}
              className="w-full bg-yellow-600 hover:bg-yellow-500 text-black py-2 rounded text-sm"
            >
              {btn}
            </button>
          ))}
        </div>
      </div>

      {/* Product Section */}
      <div className="mt-6">
        <div className="text-blue-300 font-semibold mb-2">
          Product / Service Details
        </div>

        <div className="space-y-3">
          <input className="w-full bg-gray-900 border border-gray-600 p-2 rounded" defaultValue={data.product} placeholder="Product"/>
          <input className="w-full bg-gray-900 border border-gray-600 p-2 rounded" defaultValue={data.category} placeholder="Category"/>
          <input className="w-full bg-gray-900 border border-gray-600 p-2 rounded" defaultValue={data.subCategory} placeholder="Sub Category"/>
          <textarea className="w-full bg-gray-900 border border-gray-600 p-2 rounded h-24" defaultValue={data.remarks} placeholder="Remarks"/>
        </div>
      </div>
    </div>
  );
};

export default SampleCSAT;